import gql from "graphql-tag";

let cities = JSON.parse(localStorage.getItem('cities'))
let finalCondition = '{}';
let intermediateCondition = '';
if(cities && cities.length){
    let contractorCities = cities.map(curnt => curnt.city);
    finalCondition = '{contractorAddress: {city: {_in: '+ JSON.stringify(contractorCities) +'}}}'
}

export const SUBSCRIBE_EXCEL_CONTRACTORS = gql`
  subscription contractors($searchFilter: String!, $city:String, $offset: Int!, $limit: Int!){
    contractors: contractor (where: {_and: [{_or: [${finalCondition}] },{city: {_eq: $city}},
    {_or: [{name: {_ilike: $searchFilter}},{pan: {_ilike: $searchFilter}},{email: {_ilike: $searchFilter}},{gstin: {_ilike: $searchFilter}}] }]},
            offset: $offset, limit: $limit, order_by: {createdAt: asc}){
      id
      name
      type
      contractorCode
      email
      mobile
      monthlyKms
      gstin
      pan
      city
      status
      contractorAddress{id add1 add2 area city state pincode}
      tempoOrders_aggregate { aggregate { count } }
      tempos_aggregate { aggregate { count } }
      drivers_aggregate { aggregate { count } }
    }
  }
`
export const SUBSCRIBE_CONTRACTORS_TOTALCOUNT = gql`
  subscription contractors($searchFilter: String!, $city:String){
    contractorsCount: contractor_aggregate(where: {_and: [{_or: [${finalCondition}] },{city: {_eq: $city}},
    {_or: [{name: {_ilike: $searchFilter}},{pan: {_ilike: $searchFilter}},{email: {_ilike: $searchFilter}},{gstin: {_ilike: $searchFilter}}] }
    ]}){
      aggregate{count}
    }
  }
`
export const SUBSCRIBE_TEMPO_ORDERS_BY_CONTRACTOR_ID = gql`
 subscription tempoOrdersByContractorId($searchFilter: String!, $startDate:date!, $endDate:date!, $contractorId:uuid!){
  tempoOrders(where: {_and: [{ date: {_gte: $startDate}},{ date: {_lte: $endDate}},{ contractorId: {_eq: $contractorId}},
  {_or: [{tempoOrderCode: {_ilike: $searchFilter}},{tempo:{platNo: {_ilike: $searchFilter}}},{driverDetail:{name: {_ilike: $searchFilter}}},{driverDetail:{mobile: {_ilike: $searchFilter}}}] }
  ]}, order_by: {date: desc}) {
    id
    tempoOrderCode
    contractorCode
    contractor{id name}
    date
    driverDetail{id name mobile}
    endReading
    startReading
    tempo{id name platNo capacity}
    orderDetailsArr{id order{id materials}}
    }
 }
`
export const SUBSCRIBE_CONTRACTOR_DETAIL = gql`
subscription getContractorDetail($contractorId:uuid!){
  contractorDetail: contractor(where: {id: {_eq: $contractorId}}) {
    id
    name
    type
    contractorCode
    email
    gstin
    mobile
    monthlyKms
    status
    pan
    city
    contractorAddress{id add1 add2 area city state pincode}
    tempos{
      id city name platNo kmLimit capacity hiringPrice type extraKmPrice status
      tempoOrders { id orderDetailsArr_aggregate {aggregate {count} } }
    }
    drivers{ id  name mobile driverType proof status}
   }
}
`
